import { combineReducers } from 'redux'

import {setterReducer} from '../common/redux'
import * as t from './actionTypes'

export const searchActive = (state = false, action) => {
  switch (action.type) {
    case t.SET_SEARCH_ACTIVE:
      return action.payload
    default:
      return state
  }
}

const searchSuggestions = (state = {items: [], seq: 0,  active: -1}, action) => {
  switch(action.type) {
    case t.SET_SEARCH_SUGGESTIONS:
      return {...state, items: action.payload, active: -1}
    case t.INCREMENT_AUTOSUGGEST_SEQUENCE:
      return {...state, seq: state.seq + 1}
    case t.INCREMENT_SUGGESTION:
      return {...state, active: state.active >= state.items.length-1 ? 0 : state.active + 1}
    case t.DECREMENT_SUGGESTION:
      return {...state, active: state.active <= 0 ? state.items.length - 1 : state.active - 1}
    default:
      return state
  }
}

export const submitted = (state = false, action) => {
  switch(action.type) {
    case t.SET_SUBMITTED:
      return action.payload
    case t.SET_SEARCH:
      return false
    default:
      return state
  }
}

export const finishedInputtingSymptoms = setterReducer(false, t.SET_FINISHED_INPUTTING_SYMPTOMS)
export const suggestionLoading = setterReducer(false, t.SET_SUGGESTION_LOADING)
export const searchResults = setterReducer([], t.SET_SEARCH_RESULTS)
export const searchAttempted = setterReducer(false, t.SET_SEARCH_ATTEMPTED)
export const message = setterReducer('', t.SET_SEARCH_MSG)
export const search = setterReducer('', t.SET_SEARCH)
export const header = setterReducer('', t.SET_HEADER)
export const cachedSearch = setterReducer('', t.SET_CACHED_SEARCH)
export const userIntent = setterReducer(null, t.SET_USER_INTENT)
export const userIntentCareOption = setterReducer(null, t.SET_USER_INTENT_CARE_OPTION)

const searchReducer = combineReducers({
  active: searchActive,
  finished: finishedInputtingSymptoms,
  loading: suggestionLoading,
  attempted: searchAttempted,
  suggestions: searchSuggestions,
  results: searchResults,
  cached: cachedSearch,
  message,
  search,
  header,
  submitted,
  userIntent,
  userIntentCareOption
})

export {searchReducer as default}



// WEBPACK FOOTER //
// ./assets/search/reducer.js